import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-063c03ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = {
  class: "flex abormal-flex",
  style: {"padding-top":"27px"}
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex abormal-flex" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "flex abormal-flex border-style" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "handle-way-body" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mark-title" }
const _hoisted_16 = {
  key: 0,
  class: "handlingTips"
}
const _hoisted_17 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { style: {"width":"100%"} }
const _hoisted_20 = { class: "flex-b align-item" }
const _hoisted_21 = { style: { display: 'flex' } }
const _hoisted_22 = { class: "handle-way-table-title" }
const _hoisted_23 = { class: "handle-way-table-desc" }
const _hoisted_24 = { class: "handle-way-table-batch" }
const _hoisted_25 = { class: "handle-way-table" }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 0,
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_28 = {
  key: 2,
  class: "required-style"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "dialog-footer-confirm-type" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, toRaw, onUnmounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import STable from '@/components/Table/index.vue'
import { tableConfigSkuDialog, skuDialogColumns, changeReasonCodes, confirmTypes } from '../data'
import { confirmProcessByOrder, confirmProcessBySku } from '@/apis/inShipping'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { useRequest } from '@/util/useLoading'
import { expressCostPdf, isD2C, isShowStockJpBtn } from '@/store'
import { COUNTRY } from '@/global'
import { request } from '@/config/request/interceptors'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  confirmType: {
    type: String,
    default: 'ORDER'
  }
},
  emits: ['closeDialog', 'refresh'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()

const [loading, submitApi] = useRequest((data: any) => {
  // api
  if (props.confirmType === 'ORDER') {
    return confirmProcessByOrder(data)
  } else {
    return confirmProcessBySku(data)
  }
})

const _processSkuList: any = ref([])
const selectionSkuList: any = ref([])
const batchValue = ref('')
/** 处理方式 */
const handlingWays = ref(props.rowItem.recommendShipConfigId === '-1' ? 'CANCEL' : '')
/** 提交按钮是否disabled */
const showSubmitDisabled = ref(false)
const itemRef = []
const selectRef = (el: any) => {
  if (el) {
    itemRef.push(el)
  }
}
const handleScroll = () => {
  itemRef.forEach((item) => {
    item.blur()
  })
}
onMounted(() => {
  setTimeout(() => {
    // 获取 DOM 元素
    const scrollAreaRef = document.querySelector('.handle-way-table .el-scrollbar__wrap')

    // 监听滚动事件
    scrollAreaRef!.addEventListener('scroll', handleScroll)
  }, 60)
  const arr = props.rowItem?.skuList || []
  if (arr?.length <= 0) {
    return
  }
  // 深拷贝下数组
  const newArr = JSON.parse(JSON.stringify(arr))
  const newList = newArr?.map((item: any) => {
    // 如果confirmType为0，则直接return
    if (item.confirmType !== confirmTypes.Unconfirmed) {
      return item
    }
    if (item.auditIntShipConfigId === '-1') {
      return { ...item, recommendShipConfigId: 'CANCEL' }
    }
    if (item.changeReasonCode && item.changeReasonCode !== 'AR_0010' && item.changeReasonCode !== 'AR_0000') {
      return { ...item, recommendShipConfigId: 'RECOMMEND' }
    }
    return item
  })?.toSorted((a: any, b: any) => {
    // 1、变更理由不为请选择且不是取消发货，需要放在前面
    // 2、如果confirmType为0放在后面
    const _aChangecode = (a.changeReasonCode === 'AR_0000' || a.cancelDelivery) || a.confirmType !== confirmTypes.Unconfirmed ? '' : a.changeReasonCode
    const _bChangecode = (b.changeReasonCode === 'AR_0000' || b.cancelDelivery) || b.confirmType !== confirmTypes.Unconfirmed ? '' : b.changeReasonCode
    return Number(Boolean(_bChangecode)) - Number(Boolean(_aChangecode))
  })
  /** 如果所有商品都是没有变更理由的，提交按钮不可点击 */
  const isNeedFillIn = newList?.every((item: any) => !item?.changeReasonCode)
  showSubmitDisabled.value = isNeedFillIn
  _processSkuList.value = newList
})
onUnmounted(() => {
  setTimeout(() => {
    // 获取 DOM 元素
    const scrollAreaRef = document.querySelector('.handle-way-table .el-scrollbar__wrap')

    // 监听滚动事件
    scrollAreaRef!.removeEventListener('scroll', handleScroll)
  }, 60)
})
/** 批量选择-点击Selection */
const handleSelectionChange = (val: any) => {
  const list = val.map((item: any) => {
    if (item.changeReasonCode) {
      return item
    }
  })?.filter((item: any) => !!item) || []
  selectionSkuList.value = list
}
/** change select */
const changeSelect = (val: string, row: any) => {
  const { deliveryReviewDetailId } = row
  const _data = JSON.parse(JSON.stringify(_processSkuList.value))
  const arr = _data?.map((item: any) => item.deliveryReviewDetailId)
  const index = arr.indexOf(deliveryReviewDetailId)
  // 如果有值，则去掉必填校验
  if (val) {
    _processSkuList.value[index].hasNoContent = false
  }
  _processSkuList.value[index].recommendShipConfigId = val
}
/** 批量选择处理方式 */
const changeBatchSelect = (val: string) => {
  const list = toRaw(selectionSkuList.value)
  const ids = list?.map((item: any) => item.deliveryReviewDetailId) || []
  const newList = _processSkuList.value?.map((item: any) => {
    // 取消发货直接return就行
    if (item.auditIntShipConfigId === '-1') {
      return item
    }
    const arr = ['RECOMMEND']
    if (ids.includes(item.deliveryReviewDetailId)) {
      // 如果变更理由不是价格过高，则没有保持原装选项
      if (item.changeReasonCode === 'AR_0010') {
        arr.push('REMAINING')
      }
      // 如果有该选项则修改，没有就不变
      if (arr.includes(val)) {
        item.recommendShipConfigId = val
        item.hasNoContent = false
      }
    }
    return item
  })
  _processSkuList.value = newList
}
/** 取消提交 */
const cancel = () => {
  emit('closeDialog', { visible: false })
}

const cancelOrder = async () => {
  if (!handlingWays.value) {
    ElMessage.error(t('请选择处理方式'))
    return
  }
  const cancalFn = () => {
    const { deliveryReviewCode } = props.rowItem
    let _confirmType: undefined | number = ['RECOMMEND', 'CANCEL', 'REMAINING'].indexOf(handlingWays.value)
    _confirmType = _confirmType === -1 ? undefined : _confirmType + 1
    const params = {
      deliveryReviewCode,
      confirmType: _confirmType
    }
    submitApi(params).then((res: any) => {
      const { success = false } = res
      if (!success) return
      emit('closeDialog', { visible: false })
      if (handlingWays.value === 'CANCEL') {
        ElMessage.success(t('此国际发货单已取消发货'))
      }
      if (handlingWays.value === 'RECOMMEND') {
        ElMessage.success(t('成功，此国际发货单将按照建议运输方式发货'))
      }
      if (handlingWays.value === 'REMAINING') {
        ElMessage.success(t('成功，此国际发货单将保持原运输方式发货'))
      }
      emit('refresh')
    })
  }

  const { deliveryReviewCode, deliveryTaskCode } = props.rowItem
  const res = await request.wms.wms.deliveryTaskCheckDiscardPlan({ deliveryTaskCode })
  if (!isD2C() && handlingWays.value === 'CANCEL') {
    const res1 = await ElMessageBox.confirm(`${t('如果取消当发货单，将会取消以下发货单，是否确定')}
          ${res?.data?.map((item) => {
      return `\r\n${item}`
    }).join('')
      }
       `, 'ご確認下さい',
      {
        confirmButtonText: t('确定'),
        cancelButtonText: t('取消'),
        dangerouslyUseHTMLString: true,
        type: 'warning'
      })
    if (res1) {
      cancalFn()
      return
    }
  }
  cancalFn()
}

/** 提交 */
const submit = async () => {
  if (props.confirmType === 'ORDER') {
    cancelOrder()
    return
  }
  const list = toRaw(_processSkuList.value)
  // 变更理由为请选择的需要写死字段
  const _list = JSON.parse(JSON.stringify(list)).map((item: any) => {
    // 如果变更理由为请选择，那么直接写死为（按照原来方式运输）
    if (item.changeReasonCode === 'AR_0000') {
      item.recommendShipConfigId = 'REMAINING'
    }
    // 如果建议运输方式和原运输方式一样，那么直接写死为（按照原来方式运输）
    if (item.confirmType !== confirmTypes.Unconfirmed) {
      item.recommendShipConfigId = 'REMAINING'
    }
    return item
  })
  /** 判断有select是否都必填 */
  const isQuired = _list?.every((item: any) => {
    if (item.changeReasonCode && !item.recommendShipConfigId) {
      return false
    }
    return true
  })
  // 必填校验
  if (!isQuired) {
    _processSkuList.value = _list.map((item: any) => {
      if (item.changeReasonCode && !item.recommendShipConfigId) {
        return { ...item, hasNoContent: true }
      }
      return item
    })
    return
  } else {
    _processSkuList.value = JSON.parse(JSON.stringify(_list))
  }
  /** 重新重组下数据 */
  const skuList = _processSkuList.value?.map((item: any) => {
    let _confirmType: undefined | number = ['RECOMMEND', 'CANCEL', 'REMAINING'].indexOf(item.recommendShipConfigId)
    _confirmType = _confirmType === -1 ? undefined : _confirmType + 1
    return {
      deliveryReviewDetailId: item.deliveryReviewDetailId,
      confirmType: _confirmType,
      productSku: item.productSku
    }
  })
  const params = {
    deliveryReviewCode: props.rowItem.deliveryReviewCode,
    skuList
  }

  submitApi(params).then((res: any) => {
    if (!res.success) return
    // const handlingWaysRecommend = skuList.every((item: any) => item.confirmType === 1)
    const handlingWaysRemaining = skuList.every((item: any) => item.confirmType === 3)
    // if (handlingWaysRecommend) {
    //   ElMessage.success(t('成功，此国际发货单将按照建议运输方式发货'))
    //   emit('closeDialog', false)
    //   emit('refresh')
    //   return
    // }
    if (handlingWaysRemaining) {
      ElMessage.success(t('成功，此国际发货单将保持原运输方式发货'))
      emit('closeDialog', false)
      emit('refresh')
      return
    }

    emit('closeDialog', { visible: false, isNeedWatch: true, data: res?.data }, props.rowItem)
  })
}
/** 获取变更理由 */
const getChangeReasonCodes = (row: any) => {
  // 确认类型(0:未确认 1:接受 2:取消订单 3:拒绝按照原来方式运输)
  if (row.confirmType !== confirmTypes.Unconfirmed) {
    return '-'
  }
  if (changeReasonCodes[row.changeReasonCode]) {
    return changeReasonCodes[row.changeReasonCode]
  }
  return '-'
}
/** 待确认-sku-若是有变更理由则展示不同样式 */
const tableRowClassName = ({ row }: { row: any }) => {
  //   如果建议运输方式和原运输方式一样
  if (row.originalDistributionId === row.recommendShipConfigId) {
    return 'visibility-hidden-checkbox column-border-style'
  }
  if (row.changeReasonCode && row.changeReasonCode !== 'AR_0000') {
    return 'style-high-light column-border-style'
  }
  return 'visibility-hidden-checkbox column-border-style'
}
const isWhiteStockJp = ref(false)
onMounted(async () => {
  isWhiteStockJp.value = await isShowStockJpBtn()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    class: "problem-handing-order-shipping",
    "custom-class": "problem-handing-order-shipping",
    width: props.confirmType === 'ORDER' ? '600px' : '1135px',
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('closeDialog', false))),
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_31, [
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "submit-btn",
          type: "primary",
          onClick: submit,
          disabled: showSubmitDisabled.value,
          loading: _unref(loading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(` dialog-body-content ${props.confirmType === 'ORDER' ? '' : 'dialog-body-content-sku'}`)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('原运输方式')) + "：", 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.rowItem.originalDistribution), 1)
        ]),
        (props.confirmType === 'ORDER')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('变更理由')) + "：", 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(changeReasonCodes)[__props.rowItem.changeReasonCode]), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('建议运输方式')) + "：", 1),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(__props.rowItem.recommendDistribution || _unref(t)('无可用运输方式')), 1),
                  _withDirectives(_createElementVNode("a", {
                    style: {"text-decoration":"underline"},
                    target: "_blank",
                    href: _unref(expressCostPdf)()
                  }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_12), [
                    [_vShow, __props.rowItem.goodsCountry !== _unref(COUNTRY).KR]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (props.confirmType === 'ORDER')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(`${_unref(t)('请选择处理方式')}`) + " ", 1),
                  (__props.rowItem.changeReasonCode && !__props.rowItem.recommendDistribution)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('由于没有可用的运输方式，需要您取消发货')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_radio_group, {
                  modelValue: handlingWays.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((handlingWays).value = $event))
                }, {
                  default: _withCtx(() => [
                    (__props.rowItem.changeReasonCode && __props.rowItem.recommendDistribution)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_el_radio, { label: 'RECOMMEND' }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('按照建议运输方式发货')), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      (__props.rowItem.changeReasonCode === 'AR_0010' && __props.rowItem.recommendShipConfigId !== '-1')
                        ? (_openBlock(), _createBlock(_component_el_radio, {
                            key: 0,
                            label: 'REMAINING'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('保持原运输方式发货')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_radio, { label: 'CANCEL' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('取消发货')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('商品信息')), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)('批量处理')), 1),
                    _createVNode(_component_el_select, {
                      placeholder: _unref(t)('请选择处理方式'),
                      disabled: selectionSkuList.value?.length <= 0,
                      modelValue: batchValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((batchValue).value = $event)),
                      onChange: changeBatchSelect
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _unref(t)('按照建议运输方式发货'),
                          value: 'RECOMMEND'
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _unref(t)('保持原运输方式发货'),
                          value: 'REMAINING'
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["placeholder", "disabled", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(STable, {
                    columns: _unref(skuDialogColumns),
                    onSelectionChange: handleSelectionChange,
                    tableConfig: _unref(tableConfigSkuDialog),
                    "table-data": _processSkuList.value,
                    tableRowClassName: tableRowClassName,
                    "header-row-class-name": "handle-way-header-row",
                    fixed: true,
                    "show-pagination": false,
                    height: 410
                  }, {
                    recommendDistributionHead: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('建议运输方式')) + " ", 1),
                        _withDirectives(_createElementVNode("a", {
                          class: "font-weight-normal",
                          target: "_blank",
                          style: {"text-decoration":"underline","transform":"scale(0.8)"},
                          href: _unref(expressCostPdf)()
                        }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_26), [
                          [_vShow, __props.rowItem.goodsCountry !== _unref(COUNTRY).KR]
                        ])
                      ])
                    ]),
                    productImage: _withCtx(({ row }) => [
                      (row.productImage)
                        ? (_openBlock(), _createBlock(ShoppingPreview, {
                            key: 0,
                            image: row.productImage
                          }, null, 8, ["image"]))
                        : _createCommentVNode("", true)
                    ]),
                    productSkuInfo: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(row.productSku), 1),
                      _createElementVNode("div", null, _toDisplayString(row.productPropertiesName), 1)
                    ]),
                    changeReason: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(getChangeReasonCodes(row)), 1)
                    ]),
                    recommendDistribution: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(((row.auditIntShipConfigId === '-1' || row.recommendShipConfigId === '-1') ? _unref(t)('无可用运输方式') : (
                  row.changeReasonCode === 'AR_0000' || row.confirmType !== _unref(confirmTypes).Unconfirmed ? '-' :
                    row.recommendDistribution)) || '-'), 1)
                    ]),
                    handleWay: _withCtx(({ row }) => [
                      (!!row.changeReasonCode && row.changeReasonCode !== 'AR_0000' && row.confirmType === _unref(confirmTypes).Unconfirmed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (row.auditIntShipConfigId !== '-1')
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  ref: selectRef,
                                  required: "",
                                  placeholder: _unref(t)('请选择处理方式'),
                                  modelValue: row.recommendShipConfigId,
                                  "onUpdate:modelValue": ($event: any) => ((row.recommendShipConfigId) = $event),
                                  onChange: (val) => changeSelect(val, toRaw(row))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: _unref(t)('按照建议运输方式发货'),
                                      value: 'RECOMMEND'
                                    }, null, 8, ["label"]),
                                    (row.changeReasonCode === 'AR_0010')
                                      ? (_openBlock(), _createBlock(_component_el_option, {
                                          key: 0,
                                          label: _unref(t)('保持原运输方式发货'),
                                          value: 'REMAINING'
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "onChange"]))
                              : (_openBlock(), _createBlock(_component_el_select, {
                                  key: 1,
                                  ref: selectRef,
                                  required: "",
                                  placeholder: _unref(t)('请选择处理方式'),
                                  modelValue: row.recommendShipConfigId,
                                  "onUpdate:modelValue": ($event: any) => ((row.recommendShipConfigId) = $event),
                                  onChange: (val) => changeSelect(val, toRaw(row))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: _unref(t)('取消发货'),
                                      value: 'CANCEL'
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 2
                                }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "onChange"])),
                            (row.hasNoContent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)('请选择处理方式')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, "-"))
                    ]),
                    _: 1
                  }, 8, ["columns", "tableConfig", "table-data"])
                ])
              ], 64))
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["width", "model-value"]))
}
}

})